interface IProps extends React.HTMLAttributes<HTMLElement> {
    tag?: keyof JSX.IntrinsicElements;
    className?: string;
    children?: React.ReactNode;
    styles?: React.CSSProperties;
}

const Typography = ({
    tag = 'p',
    className = '',
    styles = {},
    children,
    ...props
}: IProps) => {
    const Tag = tag as React.ElementType;

    return (
        <Tag {...props} className={`sm-typography ${className}`} style={styles}>
            {children}
        </Tag>
    );
};

export default Typography;
